export const INITIAL_STATE = {
  data: [],
  isError: false,
  isLoading: false,
}
